import { apiService } from './api';

export interface Action {
    acaoBaseId?: string;
    titulo: string;
    descricao: string;
    itemBaseId: string;
    tipoBase: "KATRU" | "ENTIDADE";
}

// Define pagination parameters
export interface PaginationParams {
    page: number;
    size: number;
    itemBaseId?: string;
    titulo?: string;
}

// Define paginated response
export interface PaginatedActionResponse {
    content: Action[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    first: boolean;
    last: boolean;
}

export const actionBaseService = {
    async getActions(params: PaginationParams): Promise<PaginatedActionResponse> {
        try {
            let url = `/acao-base?page=${params.page}&size=${params.size}`;

            if (params.itemBaseId) {
                url += `&itemBaseId=${params.itemBaseId}`;
            }

            if (params.titulo) {
                url += `&titulo=${encodeURIComponent(params.titulo)}`;
            }

            const response = await apiService.get<PaginatedActionResponse>(url);
            return response;
        } catch (error) {
            console.error('Error fetching actions:', error);
            throw error;
        }
    },

    async createAction(action: Omit<Action, 'acaoBaseId'>): Promise<Action> {
        try {
            const response = await apiService.post<Action>('/acao-base', action);
            return response;
        } catch (error) {
            console.error('Error creating action:', error);
            throw error;
        }
    },

    async updateAction(id: string, action: Partial<Action>): Promise<Action> {
        try {
            const response = await apiService.put<Action>(`/acao-base/${id}`, action);
            return response;
        } catch (error) {
            console.error('Error updating action:', error);
            throw error;
        }
    },

    async deleteAction(id: string): Promise<void> {
        try {
            await apiService.delete(`/acao-base/${id}`);
        } catch (error) {
            console.error('Error deleting action:', error);
            throw error;
        }
    },
}; 